import React from 'react';

const TableHeader = ({ sortConfig, requestSort }) => {
  return (
    <thead className="bg-gray-50 dark:bg-gray-800">
      <tr>
        <th 
          scope="col" 
          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 dark:text-gray-100 cursor-pointer sm:pl-6"
          onClick={() => requestSort('scope')}
        >
          <div className="flex items-center">
            Scope
            {sortConfig.key === 'scope' && (
              <span className="ml-1">
                {sortConfig.direction === 'ascending' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </th>
        <th 
          scope="col" 
          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100 cursor-pointer"
          onClick={() => requestSort('status')}
        >
          <div className="flex items-center">
            Status
            {sortConfig.key === 'status' && (
              <span className="ml-1">
                {sortConfig.direction === 'ascending' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </th>
        <th 
          scope="col" 
          className="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 dark:text-gray-100 cursor-pointer"
          onClick={() => requestSort('budget')}
        >
          <div className="flex items-center justify-end">
            Budget
            {sortConfig.key === 'budget' && (
              <span className="ml-1">
                {sortConfig.direction === 'ascending' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </th>
        <th 
          scope="col" 
          className="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 dark:text-gray-100 cursor-pointer"
          onClick={() => requestSort('percentage_complete')}
        >
          <div className="flex items-center justify-end">
            Complete
            {sortConfig.key === 'percentage_complete' && (
              <span className="ml-1">
                {sortConfig.direction === 'ascending' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </th>
        <th 
          scope="col" 
          className="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 dark:text-gray-100 cursor-pointer"
          onClick={() => requestSort('contracts_total')}
        >
          <div className="flex items-center justify-end">
            Contracts
            {sortConfig.key === 'contracts_total' && (
              <span className="ml-1">
                {sortConfig.direction === 'ascending' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </th>
        <th 
          scope="col" 
          className="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 dark:text-gray-100 cursor-pointer"
          onClick={() => requestSort('payments_total')}
        >
          <div className="flex items-center justify-end">
            Payments
            {sortConfig.key === 'payments_total' && (
              <span className="ml-1">
                {sortConfig.direction === 'ascending' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </th>
        <th 
          scope="col" 
          className="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 dark:text-gray-100 cursor-pointer"
          onClick={() => requestSort('remaining')}
        >
          <div className="flex items-center justify-end">
            Remaining
            {sortConfig.key === 'remaining' && (
              <span className="ml-1">
                {sortConfig.direction === 'ascending' ? '↑' : '↓'}
              </span>
            )}
          </div>
        </th>
      </tr>
    </thead>
  );
};

export default TableHeader;